module.exports = __webpack_public_path__ + "media/layer1_720p_1.07be7c57.webm";